import { useACL } from "layouts/agent/agent-info/agent-acl/_context/AgentACLContext";
import SearchTableRolesACL from "./components/SearchTableRolesACL";
import Card from "components/card";

const RoleACLDataTable = () => {
  const { aclRoles } = useACL();
  return (
    <Card extra={"w-full h-full mt-3"}>
      <SearchTableRolesACL tableData={aclRoles} />
    </Card>
  );
};

export default RoleACLDataTable;